import { CronExpressionParser } from "cron-parser";
import { differenceInMilliseconds } from "date-fns";
import { useEffect } from "react";

export type CronString =
  | "@yearly"
  | "@monthly"
  | "@weekly"
  | "@daily"
  | "@hourly"
  | "@minutely"
  | "@secondly"
  | "@weekdays"
  | "@weekends"
  | `${string} ${string} ${string} ${string} ${string} ${string}`;

export function useCron(cron: CronString, callback: () => void) {
  useEffect(() => {
    const interval = CronExpressionParser.parse(cron, { currentDate: new Date() });
    let next = interval.next().toDate();
    let timeout = window.setTimeout(step, differenceInMilliseconds(next, new Date()));
    function step() {
      try {
        callback();
      } catch (error) {
        console.error("useCron callback throw error", error);
      }
      next = interval.next().toDate();
      timeout = window.setTimeout(step, differenceInMilliseconds(next, new Date()));
    }
    return () => window.clearTimeout(timeout);
  }, [cron, callback]);
}
